<template>
    <div class="reportCase">
        <div class="report-case">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="基地发展报告" name="report" class="report-frame">
                </el-tab-pane>
                <el-tab-pane label="基地案例" name="case" class="report-frame">
                </el-tab-pane>
            </el-tabs>
            <div v-if="activeName == 'report'" class="report-main">
              <div class="report" v-for="(item,index) in reportList" :key="index" @click="openPdf(item.ossPath)">
                <!-- <pdf
                  ref="pdf"
                  :page="currentPage"
                  :src="item.icon">
                </pdf> -->
                <img style="width: 270px;height: 366px;" :src="item.icon"  alt="">
                <div class="periodicals" :title="item.intro">
                  <span>{{item.intro | limitWordText(10)}}</span>
                </div>
              </div>
            </div>
            <div v-if="activeName == 'case'" class="report-main">
            <div class="case" v-for="(item,index) in caseList" :key="index" @click="openPdf(item.ossPath)">
              <!-- <pdf
                ref="pdf"
                :page="currentPage"
                :src="item.icon">
              </pdf> -->
              <img style="width: 270px;height: 366px;" :src="item.icon"  alt="">
              <div class="periodicals" :title="item.intro">
                <span>{{item.intro | limitWordText(10)}}</span>
              </div>
            </div>
          </div>
        </div>

        <return-top></return-top>
    </div>
</template>

<script>
import ReturnTop from '@/components/returnTop.vue'
import mixins from '@/utils/mixin'
// import pdf from 'vue-pdf'
export default {
  name: 'reportCase',
  mixins: [mixins],
  props: {

  },
  components: {
    ReturnTop
    // pdf
  },
  data () {
    return {
      activeName: 'report',
      reportList: [],
      caseList: [],
      currentPage: 1
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.priorBasementMagazine()
    this.priorBasementExample()

    this.$parent.activeIndex = '5'
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    },
    // 基地发展报告pdf
    async priorBasementMagazine () {
      try {
        const res = await this.$get(this.$url.base.priorBasementMagazine)
        const { code, msg, data } = res.data
        if (code === 200) {
          // console.log(data)
          this.reportList = data
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 基地案例pdf
    async priorBasementExample () {
      try {
        const res = await this.$get(this.$url.base.priorBasementExample)
        const { code, msg, data } = res.data
        if (code === 200) {
          // console.log(data)
          this.caseList = data
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 打开pdf
    openPdf (url) {
      window.open(url)
    }
  }
}
</script>

<style scoped lang="less">
.reportCase{
   width: 100%;
   min-height: 90vh;
   background-color: #F5F5F5;
   margin-top: 8px;
   overflow: hidden;
}
.report-case{
    width: 1200px;
    min-height: 80vh;
    background-color: #fff;
    margin: 20px auto 100px;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 20px 20px 60px;
    .report-main{
      display: flex;
      flex-wrap: wrap;
    }
}
.report-frame{
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    .report:nth-of-type(4n),
    .case:nth-of-type(4n){
        margin-right: 0;
    }
    .report,
    .case{
        position: relative;
        width: 270px;
        height: 366px;
        border-radius: 1px;
        border: 1px solid #E2E2E2;
        margin: 0 10px 20px 0;
        .periodicals{
            position: absolute;
            left: 25px;
            bottom: 24px;
            width: 214px;
            height: 39px;
            line-height: 39px;
            text-align: center;
            background: #FBF5E7;
            border-radius: 20px;
            font-size: 14px;
            /deep/.el-divider--vertical{
                width: 2px;
                height: 14px;
                margin: 0 10px;
                background-color: #999;
            }
        }
    }
}

/deep/.el-tabs__item{
  font-size: 20px;
  font-weight: 600;
  padding-bottom: 50px;
}
/deep/.is-active{
  color: #3056D9;
}
/deep/.el-tabs__active-bar{
  height: 4px;
  background-color: #3056D9;
  border-radius: 2px;
}
.report,
.case{
  position: relative;
  width: 270px;
  height: 366px;
  border-radius: 1px;
  border: 1px solid #E2E2E2;
  margin: 0 18px 20px 0;
  cursor: pointer;
  overflow: hidden;
  .periodicals{
    position: absolute;
    left: 25px;
    bottom: 24px;
    width: 214px;
    height: 39px;
    line-height: 39px;
    text-align: center;
    background: #FBF5E7;
    border-radius: 20px;
    font-size: 14px;
    /deep/.el-divider--vertical{
      width: 2px;
      height: 14px;
      margin: 0 10px;
      background-color: #999;
    }
  }
}
</style>
